import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import PropTypes from 'prop-types';
import { SeriesContext } from '../context/SeriesContextProvider';
import PieArc from './PieArc';
import PieArcLabel from './PieArcLabel';
import { DrawingContext } from '../context/DrawingProvider';
import { createElement as _createElement } from "react";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const RATIO = 180 / Math.PI;
function getItemLabel(arcLabel, arcLabelMinAngle, item) {
  if (!arcLabel) {
    return null;
  }
  const angle = (item.endAngle - item.startAngle) * RATIO;
  if (angle < arcLabelMinAngle) {
    return null;
  }
  if (typeof arcLabel === 'string') {
    var _item$arcLabel;
    return (_item$arcLabel = item[arcLabel]) == null ? void 0 : _item$arcLabel.toString();
  }
  return arcLabel(item);
}
function PiePlot(props) {
  var _slots$pieArc, _slots$pieArcLabel;
  const {
    slots,
    slotProps
  } = props;
  const seriesData = React.useContext(SeriesContext).pie;
  const {
    left,
    top,
    width,
    height
  } = React.useContext(DrawingContext);
  if (seriesData === undefined) {
    return null;
  }
  const availableRadius = Math.min(width, height) / 2;
  const center = {
    x: left + width / 2,
    y: top + height / 2
  };
  const {
    series,
    seriesOrder
  } = seriesData;
  const Arc = (_slots$pieArc = slots == null ? void 0 : slots.pieArc) != null ? _slots$pieArc : PieArc;
  const ArcLabel = (_slots$pieArcLabel = slots == null ? void 0 : slots.pieArcLabel) != null ? _slots$pieArcLabel : PieArcLabel;
  return /*#__PURE__*/_jsx("g", {
    children: seriesOrder.map(seriesId => {
      const {
        innerRadius,
        outerRadius,
        cornerRadius,
        arcLabel,
        arcLabelMinAngle = 0,
        data,
        cx,
        cy,
        highlighted,
        faded
      } = series[seriesId];
      return /*#__PURE__*/_jsx("g", {
        transform: `translate(${cx === undefined ? center.x : left + cx}, ${cy === undefined ? center.y : top + cy})`,
        children: /*#__PURE__*/_jsxs("g", {
          children: [data.map((item, index) => {
            return /*#__PURE__*/_createElement(Arc, _extends({}, item, {
              key: item.id,
              innerRadius: innerRadius,
              outerRadius: outerRadius != null ? outerRadius : availableRadius,
              cornerRadius: cornerRadius,
              id: seriesId,
              color: item.color,
              dataIndex: index,
              highlightScope: series[seriesId].highlightScope,
              highlighted: highlighted,
              faded: faded
            }, slotProps == null ? void 0 : slotProps.pieArc));
          }), data.map((item, index) => {
            return /*#__PURE__*/_createElement(ArcLabel, _extends({}, item, {
              key: item.id,
              innerRadius: innerRadius,
              outerRadius: outerRadius != null ? outerRadius : availableRadius,
              cornerRadius: cornerRadius,
              id: seriesId,
              color: item.color,
              dataIndex: index,
              highlightScope: series[seriesId].highlightScope,
              formattedArcLabel: getItemLabel(arcLabel, arcLabelMinAngle, item)
            }, slotProps == null ? void 0 : slotProps.pieArcLabel));
          })]
        })
      }, seriesId);
    })
  });
}
process.env.NODE_ENV !== "production" ? PiePlot.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: PropTypes.object
} : void 0;
export { PiePlot };